import React from 'react';

import GrowerRootStackNavigator from '../Containers/GrowerPortal/GrowerRootStackNavigator';

const GrowerPortal = () => <GrowerRootStackNavigator />

export default GrowerPortal;
